import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BaseRequestOptions, HttpModule } from '@angular/http';
import { MockBackend } from '@angular/http/testing';

import { UserAuthRoutingModule } from './auth-routing.routing';
import { UserAuthComponent } from './auth.component';
import { UserLogoutComponent } from './logout/logout.component';
import { UserAuthGuard } from './_guards/auth.guard';
import { AlertService } from '../_services/alert.service';
import { UserAuthenticationService } from './_services/authentication.service';

@NgModule({
    declarations: [
        UserAuthComponent,
        //AlertComponent,
        UserLogoutComponent
    ],
    imports: [CommonModule, FormsModule, HttpModule, UserAuthRoutingModule],
    providers: [
        UserAuthGuard,
        AlertService,
        UserAuthenticationService,
        //UserService,
        // api backend simulation
        //fakeBackendProvider,
        MockBackend,
        BaseRequestOptions
    ]
    //entryComponents: [AlertComponent],
})
export class UserAuthModule { }



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/user/auth.module.ts